var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcPasswordBox(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_339_94)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_339_94)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.25 6.75V9H15.75V6.75C15.75 4.67812 14.0719 3 12 3C9.92813 3 8.25 4.67812 8.25 6.75ZM5.25 9V6.75C5.25 3.02344 8.27344 0 12 0C15.7266 0 18.75 3.02344 18.75 6.75V9H19.5C21.1547 9 22.5 10.3453 22.5 12V21C22.5 22.6547 21.1547 24 19.5 24H4.5C2.84531 24 1.5 22.6547 1.5 21V12C1.5 10.3453 2.84531 9 4.5 9H5.25Z",
    fill: "#092E5E"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_339_94"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_339_94"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 21,
    height: 24,
    fill: "white",
    transform: "translate(1.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcPasswordBox);
export default __webpack_public_path__ + "static/media/ic_password_box.c4fc6e567e248f300157db729ad1d8a4.svg";
export { ForwardRef as ReactComponent };